import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

export const reduxStore = configureStore({
  reducer: rootReducer,
  devTools: import.meta.env.MODE !== "production",
});
